import { Link } from "react-router-dom";
import type { Work } from "@/types/media";

interface WorkCardProps {
  work: Work;
}

export default function WorkCard({ work }: WorkCardProps) {
  const typeLabel = work.type === "movie" ? "电影" : "电视剧";
  return (
    <Link
      to={`/detail/${work.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/80 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-secondary-100">
        <img
          src={work.poster}
          alt={`${typeLabel}《${work.title}》剧情介绍海报`}
          title={`${work.title} - 剧情介绍与解析`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-80"></div>
        <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md text-[11px] font-medium bg-primary-500/90 text-background-50 backdrop-blur-sm">
          {typeLabel}
        </span>
        <div className="absolute bottom-3 right-3 flex items-center gap-1 px-2 py-0.5 rounded-md bg-accent-500 text-accent-950 text-xs font-bold">
          <i className="ri-star-fill text-[11px]"></i>
          {work.rating.toFixed(1)}
        </div>
        <div className="absolute bottom-3 left-3 text-background-50">
          <p className="text-xs opacity-80">{work.year} · {work.region}</p>
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {work.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{work.director} 导演</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {work.genres.slice(0, 3).map((g) => (
            <span
              key={g}
              className="px-2 py-0.5 rounded-full text-[11px] bg-secondary-100 text-secondary-800"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}